










export default {
    name: "CheckboxInput",
    components: {},
    props: {
        label: String,
        value: Boolean,
    },
    data() {
        return {
            editValue: false,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.editValue = this.value;
            },
        },
        editValue: function () {
            this.$emit("input", this.editValue);
        },
    },
};
